import index from "./signals.vue";
export default index;
